import { render, staticRenderFns } from "./wallert.vue?vue&type=template&id=313292a6&"
import script from "./wallert.vue?vue&type=script&lang=js&"
export * from "./wallert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports